/**
 * Type of a contract event the pd collector reports to a receiving partner.
 *
 * Mirrors the backend enum {@code com.mvs.backend.pd.enums.PdEventType} (persisted via
 * {@code @Enumerated(EnumType.ORDINAL)}; the value travels as the ordinal). Member names and order MUST match
 * the backend declaration exactly — append only, never insert, reorder or rename.
 */
export enum PdEventTypeEnum {
    STORNO,
    STORNO_DATE_CHANGE,
    REINSTATEMENT,
    PAYMENT_SUSPENSION,
    PAYMENT_SUSPENSION_CHANGE,
    PAYMENT_SUSPENSION_CANCELLATION,
}
